import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useBrand, type PartialBrandConfig } from "@/branding/BrandProvider";

export function DemoPage() {
  const [params] = useSearchParams();
  const { setBrand, clearBrand } = useBrand();

  useEffect(() => {
    if (params.get("reset") === "1") {
      clearBrand();
      window.location.replace("/");
      return;
    }

    const next: PartialBrandConfig = {
      name: params.get("name"),
      logoLight: params.get("logoLight"),
      logoDark: params.get("logoDark"),
      primary: params.get("primary"),
    };

    const hasAny = Object.values(next).some((v) => v != null && v !== "");
    if (hasAny) setBrand(next);

    window.location.replace("/");
  }, [params, setBrand, clearBrand]);

  return null;
}
